export default __webpack_public_path__ + "static/media/quizzical-login.513906df.jpg";